import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const items = ['Hacés sentadillas y squats y solo te crecen las piernas', 'Hacés abdominales y tu cintura se ve más ancha, no más delgada', 'Rutinas de Instagram sin técnica real ni base científica', 'Videos en inglés con cuerpos genéticos que no aplican a tu realidad', 'Meses entrenando y el glúteo sigue igual de plano', 'Sin progresión real, sin plan, sin saber si lo estás haciendo bien', 'Te mirás al espejo y la silueta no cambió absolutamente nada'];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-259">
      <div className="max-w-4xl mx-auto" data-id="element-260">
        {/* PAIN INTRO */}
        <div className="text-center mb-10 md:mb-14" data-id="element-261">
          <p className="text-red-400 font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3" data-id="element-262">
            💣 La realidad del entrenamiento femenino
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto" data-id="element-263">
            ¿Cuánto tiempo más vas a{' '}
            <span className="text-primary" data-id="element-264">entrenar sin ver resultados?</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-300 leading-relaxed max-w-3xl mx-auto mb-8" data-id="element-265">
            Sos una mujer que quiere transformar su cuerpo. Sabés lo que es
            esforzarte. Pero nadie te dio un sistema real pensado para el cuerpo
            femenino argentino.
          </p>
        </div>

        {/* PAIN POINTS VISUAL */}
        <div className="mb-10" data-id="element-266">
          <h3 className="text-xl md:text-2xl font-bold text-center mb-8 leading-tight" data-id="element-267">
            Esto es lo que te está drenando{' '}
            <span className="text-red-400" data-id="element-268">tiempo, energía y autoridad</span>
          </h3>

          <div className="grid sm:grid-cols-2 gap-3 md:gap-4" data-id="element-269">
            {items.map((item, i) => <div key={i} className="bg-surface border border-zinc-800 rounded-xl p-4 md:p-5 flex items-start gap-3 hover:border-red-500/30 transition-colors" data-id="element-270">
                <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 shrink-0 mt-0.5" data-id="element-271" />
                <span className="text-zinc-200 text-sm md:text-base" data-id="element-272">
                  {item}
                </span>
              </div>)}
          </div>
        </div>

        {/* GOLPE DE MENSAJE */}
        <div className="text-center bg-black/40 border border-primary/30 rounded-2xl p-6 md:p-8" data-id="element-273">
          <p className="text-lg md:text-2xl font-bold text-zinc-300 leading-tight" data-id="element-274">
            No es falta de esfuerzo.
            <br data-id="element-275" />
            No es falta de disciplina.
            <br data-id="element-276" />
            No es tu cuerpo.
            <br data-id="element-277" />
            <span className="text-primary text-xl md:text-3xl mt-2 block" data-id="element-278">
              Es que nadie te dio el sistema correcto.
            </span>
          </p>
        </div>
      </div>
    </section>;
}